// 体质症状详解数据
// 图片路径格式：/images/body-types/文件名.png

export const bodyTypeSymptoms = {
  '气虚质': {
    // 健康雷达数据
    healthRadar: {
      organ: '肺',
      organImage: '/images/body-types/气虚型_肺.png',
      symptoms: [
        '容易焦躁',
        '气虚',
        '小便黄',
        '容易感冒',
        '易怒',
        '便秘',
        '怕冷',
        '食欲不振',
        '多梦',
        '气虚'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '非常容易出汗',
        image: '/images/body-types/气虚型_出汗.png',
        description: '经常动不动就出汗汗液带走体内热量，容易感冒。'
      },
      {
        title: '气短、呼吸轻',
        image: '/images/body-types/气虚型_气短.png',
        description: '肺脏功能较差，说话声音怯，气息轻浅，稍微运动就容易气短。'
      },
      {
        title: '面色萎黄、口唇色淡',
        image: '/images/body-types/气虚_面黄.png',
        description: '脾虚则气血化源不足导致面部缺乏血色，面色发黄、口唇色淡。'
      },
      {
        title: '脾胃不佳',
        image: '/images/body-types/气虚_脾胃不佳.png',
        description: '容易腹胀饭量小气虚者胃口不是很好，有的人则胃强脾弱，虽然能吃，却容易腹胀，消化不良。'
      }
    ],
    // 原因分析
    causes: [
      {
        title: '得自父母',
        image: '/images/body-types/气虚型_原因_得自父母.png',
        description: '营养不母亲怀孕时进食较少，或父母有一方是气虚体质。'
      },
      {
        title: '熬夜伤神',
        image: '/images/body-types/气虚型_原因_熬夜.png',
        description: '经常熬夜容易伤神，劳伤心脾。重体力劳动者则会伤形，长期神形过劳都会耗气，加重气虚。'
      },
      {
        title: '七情不畅',
        image: '/images/body-types/气虚型_原因_七情不畅.png',
        description: '长期七情不畅、抑郁或暴怒都容易导致肝气郁结，肝木克脾土从而促生气虚。'
      },
      {
        title: '久卧伤气',
        image: '/images/body-types/气虚型_原因_久卧.png',
        description: '脾久卧不动容易导致气滞不畅，从而伤害脾胃，导致气虚。'
      },
      {
        title: '长期节食',
        image: '/images/body-types/气虚型_原因_长期节食.png',
        description: '食用伤气的食物长期节食会导致营养不足，形成气虚。长期食用一些伤元气的食也会导致气虚。'
      },
      {
        title: '其它',
        image: '/images/body-types/气虚型_原因_其他.png',
        description: '大病、久病容易伤元气;手淫、纵欲也会消耗元气长期服用清热解毒的中药，或抗生素、消炎药、激素等。则会促生或加重气虚。'
      }
    ],
    // 体质良方
    remedy: '白术乌梅山药舒和汤：补气汤汤方料包（三七、红花、大枣、黄芪、枸杞子）'
  },
  '阴虚质': {
    // 健康雷达数据
    healthRadar: {
      organ: '肝',
      organImage: '/images/body-types/阴虚型-肝.png',
      symptoms: [
        '咽喉异物感',
        '盗汗',
        '月经有血块',
        '尿频',
        '声音无力',
        '脱发',
        '打嗝',
        '腹胀满'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '水少而火旺，阴少而阳多',
        image: '/images/body-types/阴虚型_心烦失眠.png',
        description: '心烦失眠阴虚者内火攻心，常感觉胸口烦闷，情绪不稳定，注意力不集中，晚上容易惊棒失眠。'
      },
      {
        title: '形体消瘦',
        image: '/images/body-types/阴虚型_形体消瘦.png',
        description: '阴虚者胃火旺，能吃能喝，但代谢快，怎么吃也不胖，形体精悍，肌肉松弛。'
      },
      {
        title: '皮肤无华',
        image: '/images/body-types/阴虚型_皮肤无华.png',
        description: '阴虚者皮肤缺少滋润，干燥无华，面色不佳，还容易上火，常生口疮，舌头发红，常便秘。'
      },
      {
        title: '手脚发热',
        image: '/images/body-types/阴虚型_手脚发热.png',
        description: '阴虚者体内火旺，导致"五心烦热"体温正常，但手心、脚心发热，冬天也是如此。'
      },
      {
        title: '头晕易累',
        image: '/images/body-types/阴虚型_头晕易累.png',
        description: '体内精液少则则养分疏松不畅，且皆为旺火消耗，从而导致体力衰弱、头晕易累等症。'
      }
    ],
    // 原因分析
    causes: [
      {
        title: '消耗阴气',
        image: '/images/body-types/阴虚型_原因_消耗阴气.png',
        description: '阴虚者内火攻心，常感觉胸口烦闷，情绪不稳定，注意力不集中，晚上容易惊棒失眠。'
      },
      {
        title: '经常熬夜',
        image: '/images/body-types/阴虚型_原因_经常熬夜.png',
        description: '熬夜导致体内津液消耗，导致阴虚。女性经、带、产、乳等都会大最耗血，也易致阴虚。'
      },
      {
        title: '情绪压抑',
        image: '/images/body-types/阴虚型_原因_情绪压抑.png',
        description: '情绪长期得不到舒展，会郁结化火，从而促生内热，损耗阴精。'
      },
      {
        title: '先天禀赋',
        image: '/images/body-types/阴虚型_原因_先天禀赋.png',
        description: '父母是阴虚体质，很容易遗传给下一代。'
      },
      {
        title: '食物辛燥',
        image: '/images/body-types/阴虚型_原因_食物辛辣.png',
        description: '长期使用辛燥食物，如辣椒，姜、蒜等助生内火，易导致阳盛而阴衰。'
      },
      {
        title: '长期服药',
        image: '/images/body-types/阴虚型_原因_长期服药.png',
        description: '高血压、心脏病患者长期服用利尿药物，促进津液排出，从而促生或加重阴虚。'
      }
    ],
    // 体质良方
    remedy: '黄精黄芪柔润汤：润燥汤汤方料包（山药、黄芪、枸杞子、桂圆、熟地黄）'
  },
  '痰湿质': {
    // 健康雷达数据
    healthRadar: {
      organ: '肝',
      organImage: '/images/body-types/痰湿型_肝.png',
      symptoms: [
        '腰酸',
        '夜间尿多',
        '眼睛干涩',
        '脱发',
        '腹冷',
        '某些时段容易疲累',
        '头发油',
        '容易焦躁'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '肥胖',
        image: '/images/body-types/痰湿型_肥胖.png',
        description: '多表现为大腹便便，是因为脾胃运化功能相对不足，导致体内水液不能布散而成痰湿。'
      },
      {
        title: '贪睡',
        image: '/images/body-types/痰湿型_贪睡.png',
        description: '脾主思，脾虚易致贪睡。而且痰湿者血液黏稠度较高，血气运行不畅，脑部供血不足，因此贪睡无力。'
      },
      {
        title: '油腻',
        image: '/images/body-types/痰湿型_油腻.png',
        description: '皮肤毛孔也是人体代谢通道之一，痰湿者的皮肤代谢物往往比较油腻、黏稠，极易形成痤疮。'
      },
      {
        title: '出汗多或无汗',
        image: '/images/body-types/痰湿型_出汗.png',
        description: '痰湿者要么出汗太多，导致体味，要么就是少汗无汗。'
      },
      {
        title: '小便浑浊、起泡沫',
        image: '/images/body-types/痰湿型_小便混浊.png',
        description: '痰湿者体液黏稠，因此常见小便浑浊之状。'
      },
      {
        title: '舌头胖大，舌苔厚',
        image: '/images/body-types/痰湿型_舌头胖大.png',
        description: '此时不宜再进行秋冬进补，否则痰湿更重。'
      },
      {
        title: '经少、经迟甚至闭经',
        image: '/images/body-types/痰湿型_经少.png',
        description: '如果痰湿肥胖和月经不调混在一起，将很难治疗。'
      },
      {
        title: '动作缓慢，反应迟钝',
        image: '/images/body-types/痰湿型_动作缓慢.png',
        description: '痰湿者脑部供血不足，往往反应比较迟钝。'
      },
      {
        title: '不爱喝水，喝水易腹胀',
        image: '/images/body-types/痰湿型_不爱喝水.png',
        description: '痰湿者口中黏腻，很少口渴，喝水也不易吸收易致腹胀。'
      }
    ],
    // 原因分析
    causes: [
      {
        title: '不爱运动',
        image: '/images/body-types/痰湿型_原因_不爱运动.png',
        description: '久坐，长时间含胸驼背，压迫肺部呼吸浅，再加上空气污染，会导致氧气不足，体内的食物很难代谢，致使痰湿堆积于体内。'
      },
      {
        title: '食物肥腻',
        image: '/images/body-types/痰湿型_原因_食物肥腻.png',
        description: '食物肥腻、寒凉，暴饮暴食；常吃减肥药，常发怒、情志不舒展，导致伤肝，转而伤脾。不吃早餐，熬夜吃夜宵，饮酒过多，伤肝转而伤脾，饮食不节易伤脾胃。'
      },
      {
        title: '食盐过多',
        image: '/images/body-types/痰湿型_原因_食盐过多.png',
        description: '长时间口味偏咸，食盐太多。口味过重，长期吃盐太多也会增加水湿，既伤脾，也伤肾。'
      }
    ],
    // 体质良方
    remedy: '茯苓莲子清畅汤：化湿汤汤方料包（茯苓、陈皮、薏米、山楂、荷叶）'
  },
  '湿热质': {
    // 健康雷达数据
    healthRadar: {
      organ: '脾',
      organImage: '/images/body-types/湿热型_脾.png',
      symptoms: [
        '喜热饮、病症遇寒加重',
        '夜间尿多',
        '尿量少',
        '皮肤痒',
        '唇暗沉',
        '大便次数多',
        '口不渴'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '口臭、体味大',
        image: '/images/body-types/湿热型_口臭.png',
        description: '身体内外不清洁，就容易形成口臭、体臭，甚至比痰湿体质的体味更难闻。'
      },
      {
        title: '面色发黄、油腻',
        image: '/images/body-types/湿热型_面色发黄.png',
        description: '湿热体质者皮肤不佳，偏油性，面部经常给人以油腻的感觉。'
      },
      {
        title: '舌苔、牙齿发黄、牙龈红肿',
        image: '/images/body-types/湿热型_舌苔.png',
        description: '舌苔发黄牙龈红肿都是体内火大气盛的表现。'
      },
      {
        title: '面部生痤疮，局部生痈疽',
        image: '/images/body-types/湿热型_面部生痤疮.png',
        description: '体内湿热之气聚积，就容易生痤疮，如不及时处理，可能会恶化成毒疮。'
      },
      {
        title: '情绪急躁',
        image: '/images/body-types/湿热型_情绪急躁.png',
        description: '湿热体质越明显，情绪越急躁易怒还容易紧张，肝胆疾病，泌尿生殖系统疾病等。'
      }
    ],
    // 原因分析
    causes: [
      {
        title: '肝胆脾胃功能失调',
        image: '/images/body-types/湿热型_原因_肝胆脾胃功能失调.png',
        description: '长期饮食不节，导致肝胆脾胃功能紊乱，或者患有肝炎，或者是肝炎病毒携带者，都很容易形成湿热体质。'
      },
      {
        title: '抽烟、喝酒、熬夜',
        image: '/images/body-types/湿热型_原因_抽烟.png',
        description: '吸烟者往往面容憔悴，牙齿黑黄，喝酒、熬夜则伤肝胆，进而伤脾胃，从而促进湿热体质。'
      },
      {
        title: '情绪压抑',
        image: '/images/body-types/湿热型_原因_情绪压抑.png',
        description: '长期情绪压抑会伤肝胆，导致体内湿热无法疏泻，如果再借酒消愁，更容易形成湿热内蕴体质。'
      },
      {
        title: '先天遗传',
        image: '/images/body-types/湿热型_原因_先天遗传.png',
        description: '一些具有湿热体质的父母，往往会将其体质传给下一代。'
      },
      {
        title: '环境湿热',
        image: '/images/body-types/湿热型_原因_环境湿热.png',
        description: '长期生活在湿热环境中的人比其他人更易形成湿热内蕴体质。'
      },
      {
        title: '滋补过度或滋补不当',
        image: '/images/body-types/湿热型_原因_滋补过度.png',
        description: '滋补过度，或本来已经有内热倾向，又在进补，就很容易促生湿热体质。'
      }
    ],
    // 体质良方
    remedy: '百合桔红畅舒汤：清热汤汤方料包（茵陈、苦瓜、绿豆、薏米、赤小豆）'
  },
  '阳虚质': {
    // 健康雷达数据
    healthRadar: {
      organ: '心',
      organImage: '/images/body-types/阳虚型_心.png',
      symptoms: [
        '容易焦躁',
        '大便硬',
        '便秘',
        '大便黏',
        '怕冷',
        '便溏'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '消化不良',
        image: '/images/body-types/阳虚型_消化不良.png',
        description: '阳虚者肠胃动力不足，对食物的消化不彻底，经常腹泻。'
      },
      {
        title: '畏寒怕冷',
        image: '/images/body-types/阳虚型_畏惧寒冷.png',
        description: '阳虚者体内阳气不足，腹部、背部特别怕冷，冬季手冷过肘，足冷过膝。'
      },
      {
        title: '脉象沉细无力',
        image: '/images/body-types/阳虚型_脉象细沉.png',
        description: '阳虚者血液循环的动力不足，往往脉象软弱，沉细无力。'
      },
      {
        title: '舌头胖大',
        image: '/images/body-types/阳虚型_舌头胖大.png',
        description: '阳虚者对体内水分消耗不足，导致舌头胖大娇嫩，边缘有明显的齿痕。'
      },
      {
        title: '精神不振',
        image: '/images/body-types/阳虚型_精神萎靡.png',
        description: '阳虚者肾阳不足，精神萎靡，性格安静，尿频尿多，性欲减退，常有脱发，黑眼圈等症状。'
      }
    ],
    // 原因分析
    causes: [
      {
        title: '穿着不保暖',
        image: '/images/body-types/阳虚型_原因_穿着不保暖.png',
        description: '也就是"要风度不要温度"，经常将肩、腰、腿暴露在外，也会导致或加重阳虚。'
      },
      {
        title: '纵欲过度',
        image: '/images/body-types/阳虚型_原因_纵欲过度.png',
        description: '纵欲、性生活过度、不节制等，均能导致或加重阳虚。'
      },
      {
        title: '长期服药',
        image: '/images/body-types/阳虚型_原因_长期服药.png',
        description: '长期使用抗生素、利尿剂、激素类药物、清热解毒中药等会导致或加重阳虚。'
      },
      {
        title: '环境寒凉',
        image: '/images/body-types/阳虚型_原因_环境寒冷.png',
        description: '在冷库等寒凉环境中工作，或者空调使用过度，也容易形成阳虚。'
      },
      {
        title: '先天禀赋',
        image: '/images/body-types/阳虚型_原因_先天禀赋.png',
        description: '父母为阳虚体质，或者高龄婚育、孕期过食寒凉食物都可能导致胎儿形成寒凉体质。'
      }
    ],
    // 体质良方
    remedy: '肉苁蓉覆盆子虚逆汤：温阳汤汤方料包（肉桂、干姜、当归、黄芪、大枣）'
  },
  '气郁质': {
    // 健康雷达数据
    healthRadar: {
      organ: '肝',
      organImage: '/images/body-types/气郁型_肝.png',
      symptoms: [
        '腰酸',
        '容易焦躁',
        '口臭',
        '口渴',
        '下肢无力',
        '摄取大量水份',
        '夜间尿多',
        '小便黄'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '形体',
        image: '/images/body-types/气郁型_形体.png',
        description: '形体消瘦或偏胖。'
      },
      {
        title: '面色',
        image: '/images/body-types/气郁型_面色.png',
        description: '面色苍暗或萎黄。'
      },
      {
        title: '舌苔',
        image: '/images/body-types/气郁型_舌苔.png',
        description: '舌头呈淡红色，舌苔发白，脉弦。'
      },
      {
        title: '疼痛',
        image: '/images/body-types/气郁型_疼痛.png',
        description: '一旦生病则胸肋胀痛或窜痛。'
      },
      {
        title: '经带',
        image: '/images/body-types/气郁型_经带.png',
        description: '月经前乳房及小腹胀痛，月经不调，痛经。'
      },
      {
        title: '咽痛',
        image: '/images/body-types/气郁型_咽痛.png',
        description: '咽中梗阻，如有异物；或颈项瘤结。'
      },
      {
        title: '脾胃',
        image: '/images/body-types/气郁型_脾胃.png',
        description: '胃脘胀痛，泛吐酸水，呃逆嗳气。'
      },
      {
        title: '二便',
        image: '/images/body-types/气郁型_二便.png',
        description: '常常腹部肠鸣，大便干燥，泄利不爽。'
      },
      {
        title: '睡眠',
        image: '/images/body-types/气郁型_睡眠.png',
        description: '体内之气逆行，常有头痛眩晕，睡眠不佳。'
      }
    ],
    // 原因分析
    causes: [
      {
        title: '先天遗传',
        image: '/images/body-types/气郁型_原因_先天遗传.png',
        description: '如果母亲是气郁体质，且在怀孕的时候情志不展、郁郁不乐，就容易将气郁体质遗传给下一代。'
      },
      {
        title: '年幼受打击',
        image: '/images/body-types/气郁型_原因_幼年受打击.png',
        description: '人在年幼时心理发育不成熟，如果多次遭遇家庭生活不幸，或在学校、社会受到歧视。'
      },
      {
        title: '工作压力太大',
        image: '/images/body-types/气郁型_原因_工作大压力.png',
        description: '一些白领压力大，饱受上级压制，感觉自己怀才不遇，长此以往也容易形成气郁，尤其上司是强势女性的尤为常见。'
      },
      {
        title: '欲望长期达不到满足',
        image: '/images/body-types/气郁型_原因_欲望.png',
        description: '有些人欲望多，但却难以实现，一旦遭受挫折，就容易陷入抑郁，如果长时间得不到调整，就会形成气郁体质。'
      }
    ],
    // 体质良方
    remedy: '酸枣仁菊花舒和汤：疏肝汤汤方料包（玫瑰花、佛手、陈皮、香附、郁金）'
  },
  '平和质': {
    // 健康雷达数据
    healthRadar: {
      organ: '阴阳气血调和',
      organImage: '/images/body-types/平和质_肺腑.png',
      symptoms: [
        '平时较少生病',
        '面色、肤色润泽',
        '头发稠密有光泽',
        '目光有神',
        '精力充沛',
        '不易疲劳',
        '耐受寒热',
        '睡眠安和'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '健康典范',
        image: '/images/body-types/平和质_肺腑.png',
        description: '平和体质是中医九种体质中最理想的状态，表现为气血调和、阴阳平衡，身体无明显偏颇。这类人群通常精力充沛、面色红润、睡眠良好、饮食正常、二便通畅，且情绪稳定、适应力强，患病风险较低。'
      }
    ],
    // 原因分析
    causes: [],
    // 体质良方
    remedy: '山药芡实黄精臻润汤：和元汤汤方料包（珍珠、阿胶、枸杞子、山药、红枣）'
  },
  '血瘀质': {
    // 健康雷达数据
    healthRadar: {
      organ: '心脏',
      organImage: '/images/body-types/血瘀型_心脏.png',
      symptoms: [
        '头痛',
        '胸胁痛',
        '关节痛',
        '心脉瘀阻',
        '胸闷',
        '痛经',
        '小腹冷痛',
        '经血色暗'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '皮肤暗沉',
        image: '/images/body-types/血瘀型_皮肤暗沉.png',
        description: '血瘀体质者血液循环不畅，常表现为皮肤暗沉、色素沉着或出现瘀斑，尤其在面部和四肢更为明显。'
      },
      {
        title: '舌象异常',
        image: '/images/body-types/血瘀型_舌象异常.png',
        description: '血瘀体质者的舌头常呈紫暗色，舌下静脉曲张明显，舌面可能有瘀点或瘀斑，此为中医诊断血瘀的重要依据。'
      },
      {
        title: '情绪不稳',
        image: '/images/body-types/血瘀型_情绪不稳.png',
        description: '血瘀会影响气血运行，导致情绪波动，表现为易怒、焦虑、抑郁，长期血瘀可能加重心理负担。'
      },
      {
        title: '疼痛不适',
        image: '/images/body-types/血瘀型_疼痛不适.png',
        description: '血瘀会导致局部气血运行受阻，常出现疼痛，如头痛、胸痛、关节痛等，且疼痛部位固定，按压后加重。'
      }
    ],
    // 原因分析
    causes: [
      {
        title: '气滞',
        image: '/images/body-types/血瘀型_原因_气滞.png',
        description: '气滞是指气的运行不畅，导致血液运行受阻形成血瘀。长期情绪抑郁、压力过大或久坐不动可能导致气滞血瘀。患者可能出现胸胁胀痛、月经不调等症状。'
      },
      {
        title: '寒凝',
        image: '/images/body-types/血瘀型_原因_寒凝.png',
        description: '寒邪侵袭可使血脉收缩凝滞，形成寒凝血瘀。长期受寒、贪凉饮冷或居住环境潮湿阴冷可能引发。常见症状包括四肢冰冷、痛经加重等。'
      },
      {
        title: '热毒',
        image: '/images/body-types/血瘀型_原因_热毒.png',
        description: '热毒炽盛可灼伤血脉，使血液黏稠瘀滞。常见于感染性疾病、炎症反应等情况。患者可能出现局部红肿热痛、出血色暗等症状。'
      },
      {
        title: '气虚',
        image: '/images/body-types/血瘀型_原因_气虚.png',
        description: '气虚无力推动血液运行，可导致气虚血瘀。多见于久病体虚、年老体弱人群。常见症状有乏力、面色苍白、舌淡紫等。'
      },
      {
        title: '外伤',
        image: '/images/body-types/血瘀型_原因_外伤.png',
        description: '跌打损伤可直接破坏血管，使血液溢出脉外形成瘀血。常见于运动损伤、意外伤害等情况。表现为局部青紫肿胀、疼痛拒按。'
      }
    ],
    // 体质良方
    remedy: '参芪石斛醇养汤：活血汤汤方料包（三七、丹参、红花、桃仁、当归）'
  },
  '特禀质': {
    // 健康雷达数据
    healthRadar: {
      organ: '脾胃',
      organImage: '/images/body-types/特禀型_脾胃.png',
      symptoms: [
        '皮肤容易过敏',
        '容易生病',
        '哮喘',
        '湿疹',
        '抵抗力下降'
      ]
    },
    // 症状列表
    symptoms: [
      {
        title: '容易出现过敏反应',
        image: '/images/body-types/特禀型_过敏.png',
        description: '特禀体质一般是遗传因素导致，特禀体质的身体一般较虚弱，身体中的气血虚损，不能抵御外邪，可能会出现打喷嚏、咳嗽等过敏反应，甚至诱发荨麻疹。'
      },
      {
        title: '哮喘',
        image: '/images/body-types/特禀型_哮喘.png',
        description: '特禀体质者因过敏反应，喉咙可能会发生水肿，可能会影响呼吸，从而诱发哮喘，出现呼吸困难、胸闷、鼻塞等症状。'
      },
      {
        title: '湿疹',
        image: '/images/body-types/特禀型_湿疹.png',
        description: '特禀体质的人群可能会对生活中的花粉、尘螨、动物毛发等物质比较敏感，当接触到此类物质时，可能会诱发湿疹，从而出现皮肤瘙痒、红肿、丘疹等不适症状。'
      },
      {
        title: '抵抗力下降',
        image: '/images/body-types/特禀型_抵抗力下降.png',
        description: '特禀体质人群的身体比较虚弱，容易受到细菌、病毒等致病菌的入侵，从而出现反复生病的情况。'
      }
    ],
    // 原因分析
    causes: [
      {
        title: '遗传因素',
        image: '/images/body-types/特禀型_原因_遗传.png',
        description: '特禀体质可能由父母遗传给子女，导致个体易感性差异。'
      },
      {
        title: '先天禀赋不足',
        image: '/images/body-types/特禀型_原因_先天禀赋不足.png',
        description: '先天禀赋不足是指出生时身体素质较差，无法承受某些外邪侵袭，从而容易出现特禀体质。'
      },
      {
        title: '家族遗传过敏史',
        image: '/images/body-types/特禀型_原因_家族遗传.png',
        description: '免疫功能异常可能导致机体对某些物质产生过度反应，表现为特禀体质。调节免疫功能是治疗特禀体质的关键。'
      },
      {
        title: '内分泌紊乱',
        image: '/images/body-types/特禀型_内分泌紊乱.png',
        description: '内分泌紊乱会导致体内激素水平失衡，影响免疫系统的正常功能，进而诱发特禀体质。'
      }
    ],
    // 体质良方
    remedy: '党参当归优养汤：固本汤汤方料包（黄芪、白术、防风、灵芝、乌梅）'
  }
};
